import { useParams } from 'react-router-dom';
import NotFound from '../NotFound/NotFound';
import UserProfile from './UserProfile';
import {
  isLikelyUsernamePathSegment,
  isProfileUuid,
} from '../../../helpers/profilePaths';

/**
 * Resolves /:username — only UUIDs (legacy single-segment) or valid handle segments load UserProfile.
 * Prevents reserved words like "creations" from matching before static routes in some edge cases.
 */
function PublicProfileGate() {
  const { username } = useParams();

  if (isProfileUuid(username)) {
    return <UserProfile />;
  }

  if (!isLikelyUsernamePathSegment(username)) {
    return <NotFound label="Page Not Found" />;
  }

  return <UserProfile />;
}

export default PublicProfileGate;
